import { IconButton, Icon, Menu, MenuItem } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useExportSite } from '../../hooks/site/useExportSite';
import { saveAs } from 'file-saver';
const SiteMenuButton = ({ siteId }) => {
    const { exportSiteData, exportSite } = useExportSite(siteId);
    const [menuAnchor, setMenuAnchor] = useState(null);
    useEffect(() => {
        setMenuAnchor(null);
        if (exportSiteData) {
            const blob = new Blob([JSON.stringify(exportSiteData, undefined, 2)], {
                type: 'application/json'
            });
            saveAs(blob, `${exportSiteData.name}.json`);
        }
    }, [exportSiteData]);
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { className: 'site-menu-button', color: 'inherit', size: 'small', onClick: e => {
                setMenuAnchor(e.currentTarget);
            } },
            React.createElement(Icon, null, "more_vert")),
        React.createElement(Menu, { id: 'more-menu', anchorEl: menuAnchor, keepMounted: true, open: Boolean(menuAnchor), onClose: () => {
                setMenuAnchor(null);
            } },
            React.createElement(MenuItem, { onClick: () => exportSite() }, "Export"))));
};
export default SiteMenuButton;
//# sourceMappingURL=SiteMenuButton.js.map